"use client";

import { JSX, type ReactNode } from "react";
import { ConsentProvider } from "lib/consent/ConsentContext";
import {
  clearDeniedCookies,
  clearDowngradedCookies,
} from "lib/consent/clearDowngradedCookies";

export const SiteConsentProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <ConsentProvider
    onDowngrade={clearDowngradedCookies}
    onResweep={clearDeniedCookies}
  >
    {children}
  </ConsentProvider>
);

export default SiteConsentProvider;
